import {
  canAccessCampaignTab,
  canAccessOwnerAccountSettings,
  isConcierge,
} from "../../users/accountRole"
import { SETTINGS_TABS } from "./settingsTabs"

/**
 * Ordered Settings tabs this user can open. Hiding is UI-only; the backend
 * guards (user_can_access_billing, user_can_manage_*) are the real check.
 *
 * Concierges get Profile, Phone & SMS, Email, Calendar, the recruiting script
 * (read-only, see CampaignScriptSection) and Concierge sessions.
 */
export function getVisibleSettingsTabs(profile) {
  const owner = canAccessOwnerAccountSettings(profile)
  const concierge = isConcierge(profile)
  // Email: owners get Gmail/Outlook; concierges get the Zoho mailbox.
  // Phone & SMS: owners get full connect + A2P; concierges get calling + SMS DID.
  const connections = owner || concierge
  return [
    { tab: SETTINGS_TABS.profile },
    owner && { tab: SETTINGS_TABS.crmSettings },
    owner && { tab: SETTINGS_TABS.team, badge: "New" },
    connections && { tab: SETTINGS_TABS.phoneSms },
    connections && { tab: SETTINGS_TABS.configureEmail },
    connections && { tab: SETTINGS_TABS.acuityCalendar },
    canAccessCampaignTab(profile) && { tab: SETTINGS_TABS.campaign },
    // The Concierge page is the client's view of their concierges (and their
    // template approvals), so concierges themselves don't get it.
    !concierge && { tab: SETTINGS_TABS.concierge, badge: "New" },
    concierge && { tab: SETTINGS_TABS.session },
    owner && { tab: SETTINGS_TABS.planBilling },
  ].filter(Boolean)
}
